import { put, takeEvery } from "redux-saga/effects"
import { fetchGraphMethod, fetchMethod } from "../../services/httpService"
import messagePopup from "../../utils/messagePopup"

// ========================================== Action Type =====================================================
export const actionType = {
    GRADUATION_YEARS_LIST_START: 'GRADUATION_YEARS_LIST_START',
    GRADUATION_YEARS_LIST_SUCCESS: 'GRADUATION_YEARS_LIST_SUCCESS',
    GRADUATION_YEARS_LIST_FAILED: 'GRADUATION_YEARS_LIST_FAILED'
}

// ============================================ Actions ========================================================
export const graduationYearsListStart = (data) => ({
   type: actionType.GRADUATION_YEARS_LIST_START,
   payload: data
})

export const graduationYearsListSuccess = (data) => ({
    type: actionType.GRADUATION_YEARS_LIST_SUCCESS,
    payload: data
})

export const graduationYearsListFailed = (data) => ({
    type: actionType.GRADUATION_YEARS_LIST_FAILED,
    payload: data
})

// =========================================== Reducer ===========================================================
const INIT_STATE = {
    loading: false,
    data: null,
    error: null
}

export default function graduationYearsListReducer(state = INIT_STATE,action){
  switch(action.type){
      case actionType.GRADUATION_YEARS_LIST_START: 
        return {
            ...state,
            loading: true
        }
      case actionType.GRADUATION_YEARS_LIST_SUCCESS:
        return {
            ...state,
            loading: false,
            data: action.payload,
            error: null
        }  
      case actionType.GRADUATION_YEARS_LIST_FAILED:
        return {
            ...state,
            loading: false,
            data: null,
            error: action.payload
        }       
      default: return {...state}  
  }
} 

// ===================================================== side effect =============================================

export function* graduationYearsListSaga(action){
   try {
    const response = yield fetchMethod(`/allGraduationYears`,null,'get',false);
    if(response && response.status === 200){
       const allGraduationyears = response.data.data ? response.data.data : null
       yield put(graduationYearsListSuccess(allGraduationyears));
    } else {
      messagePopup('','Graduation Years List failed','error')   
      yield put(graduationYearsListFailed('Graduation Years List failed')) 
    }
   } catch (error) {
     messagePopup('','Graduation Years List failed','error')   
     yield put(graduationYearsListFailed('Graduation Years List failed')) 
   }
}

export function* watchFGraduationYearsListSaga(){
    yield takeEvery(actionType.GRADUATION_YEARS_LIST_START, graduationYearsListSaga)
}